const formatStr = (value, length = 20, suffix) => {
  if (!value) return ''
  if (value.length <= length) return value
  return value.substring(0, length) + suffix
}


/**
 * 拆分规格字符串
 * 示例: "600克/罐" -> ["600", "克", "罐"]
 */
const parseSpec = (str) => {
  return str.match(/\d+|[^\d/]+|\//g) || [];
}

// 判断是否为整数
const isInteger = (val) => {
  const regex = /^-?\d+$/;
  return regex.test(val);
}

/**
 * 根据规格计算箱数
 */
const calcBoxNum = (qty ,spec) => {
  if (!qty || !spec ) {
    return 0
  }
  const specs = parseSpec(spec);
  if (!specs || specs.length  === 0) {
    return 0
  }
  const unit = specs[0]
  if (!unit || !isInteger(unit)) {
    return 0
  }
  return Math.round(qty / unit)
}
export default {
  formatStr,
  parseSpec,
  calcBoxNum
}



// WEBPACK FOOTER //
// ./src/util/utils.js